import { ACTIVE_CUSTOMER_DISPLAY, ENABLE_CUSTOMER_DISPLAY } from 'redux/types'
import {
  createCustomerDisplaySetting,
  getCustomerDisplaySetting,
  searchCustomerDisplaySettings,
  updateCustomerDisplaySetting,
  deleteCustomerDisplaySetting,
} from 'api/core'

export const setActiveCustomerDisplay = payload => {
  return {
    type: ACTIVE_CUSTOMER_DISPLAY,
    payload,
  }
}

export const setEnabledCustomerDisplay = payload => {
  return {
    type: ENABLE_CUSTOMER_DISPLAY,
    payload,
  }
}

export const addCustomerDisplaySetting = payload => async () => {
  try {
    const response = await createCustomerDisplaySetting(payload)
    const { status } = response
    return [200, 201].includes(status)
  } catch (error) {
    console.error('Error adding customer display setting:', error)
    return false
  }
}

export const retrieveCustomerDisplaySetting = id => async () => {
  const response = await getCustomerDisplaySetting(id)
  const { data, status } = response
  if (status === 200 && data?.Data) {
    return data.Data[0]
  }
}

export const fetchCustomerDisplaySettings = payload => async () => {
  const response = await searchCustomerDisplaySettings(payload)
  const { data, status } = response
  if (status === 200 && data?.Data) {
    return data.Data
  }
}

export const modifyCustomerDisplaySetting = payload => async () => {
  try {
    const response = await updateCustomerDisplaySetting(payload)
    const { status } = response
    return [200, 201].includes(status)
  } catch (error) {
    console.error('Error modifying customer display setting:', error)
    return false
  }
}

export const removeCustomerDisplaySetting = payload => async () => {
  try {
    const response = await deleteCustomerDisplaySetting(payload)
    const { status } = response
    return status === 200
  } catch (error) {
    console.error('Error removing customer display setting:', error)
    return false
  }
}
